import { render, staticRenderFns } from "./BaseAssa.vue?vue&type=template&id=f3d350a2&"
import script from "./BaseAssa.vue?vue&type=script&lang=js&"
export * from "./BaseAssa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports